import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'
import { Trash } from 'react-feather'

export const FilterContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 1.2rem;
    gap: 1.8rem;
    align-items: center;
    width: 100%;
`

export const CustomTextFieldBadge = styled(TextFieldMui)`
    margin: 0 !important;
    width: 38rem !important;
    height: 2.5rem !important;

    & input {
        height: 1.5rem !important;
    }
`

export const CustomButtonBadge = styled(ButtonMui)`
    width: 16rem !important;    
    height: 3rem !important;
    margin: 0 !important;
    margin-top: 0.5rem !important;
    margin-bottom: 1rem !important;
`

export const RemoveBatchButton = styled(Trash)`
    cursor: pointer;
    color: red;
`

export const CustomButton = styled(ButtonMui)`
    width: 16rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`

export const CustomContainerTextArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
    gap: 1.5rem;
    align-items: center;
    justify-content: center;
    max-width: 40%;
    width: 40%;
`
